import React from 'react'
import { NotificationManager } from 'react-notifications'

const AppointmentCard = ({key, appointment,handleEdit}) => {
  // Format date for display
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = date.toLocaleString('default', { month: 'short' }).toLowerCase();
    return { day, month };
  };

  // Format time for display
  const formatTime = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleTimeString('en-US', { 
      hour: '2-digit', 
      minute: '2-digit',
      hour12: false 
    });
  };

  // Copy link to clipboard (converted from React Native to web)
  const copyLink = async (token) => {
    try {
      const link = `${process.env.REACT_APP_HOST_FE_URL}/#/location-fetcher?FLBLK=${token}`;
          console.log('Generated link:', link); // check this in browser console
      await navigator.clipboard.writeText(link);
      // Show notification using react-notifications
      NotificationManager.success('Link copied to clipboard!', 'Success', 3000);
    } catch (err) {
      console.error('Failed to copy link: ', err);
      NotificationManager.error('Failed to copy link', 'Error', 3000);
    }
  };

  // Get status-based text CSS class
  const getStatusTextClass = (status) => {
    const statusLower = status?.toLowerCase();
    switch (statusLower) {
      case 'completed':
        return 'text-status-completed';
      case 'cancelled':
        return 'text-status-cancelled';
      case 'rejected':
        return 'text-status-rejected';
      case 'pending':
        return 'text-status-pending';
      case 'accepted':
        return 'text-status-accepted';
      case 'assigned':
        return 'text-status-assigned';
      default:
        return 'text-status-pending';
    }
  };

  const startDate = formatDate(appointment.start_from);
  const startTime = formatTime(appointment.start_from);
  const endTime = formatTime(appointment.end_at);
  const statusTextClass = getStatusTextClass(appointment.process);

  return (
    <div className="container d-flex justify-content-center align-items-center">
      <div className="row">
        <div className="col-lg-4">
          <div className="card card-margin border-none">
            <div className="card-header no-border">
              <h5 className="card-title">{appointment.name}</h5>
            </div>
            <div className="card-body pt-0">
              <div className="widget-49">
                <div className="widget-49-title-wrapper">
                  <div className="widget-49-date-primary">
                    <span className={`widget-49-date-day ${statusTextClass}`}>{startDate.day}</span>
                    <span className={`widget-49-date-month ${statusTextClass}`}>{startDate.month}</span>
                  </div>
                    <div className="widget-49-meeting-info">
                      <span className={`widget-49-pro-title ${statusTextClass}`}>{appointment.process}</span>
                      <span className="widget-49-meeting-time">{startTime} to {endTime}</span>
                    </div>
                </div>
                <ol className="widget-49-meeting-points">
                  <li className="widget-49-meeting-item mb-2">
                    <span> {appointment.address}</span>
                  </li>
                  <li className="widget-49-meeting-item">
                    <span className="d-flex align-items-center">
                      <ul>
                        {appointment.assigned_to && appointment.assigned_to.length > 0 
                          ? appointment.assigned_to.map((assignee, index) => (
                              <li key={index}>
                                {assignee.full_name || assignee.name || assignee.email || 'Unknown'}
                              </li>
                            ))
                          : <span className="text-muted">Not assigned</span>
                        }
                      </ul>
                    </span>
                  </li>
                  <li className="widget-49-meeting-item">
                    <span>{appointment.mobile}</span>
                  </li>
                  {appointment.description && (
                    <li className="widget-49-meeting-item">
                      <span> {appointment.description}</span>
                    </li>
                  )}
                </ol>
                <div className="widget-49-meeting-action">
                  <button 
                    onClick={() => copyLink(appointment.unique_key)} 
                    className="btn btn-sm btn-flash-border-primary me-2 border"
                  >
                    Copy Link
                  </button>
                  <button onClick={()=> handleEdit(appointment)}
                  href="#" className="btn btn-sm btn-flash-border-primary border">Edit</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AppointmentCard